// ULTRA Test-Standort (Simulation)
// =================================
//
// Privat-Feature zum Testen vor dem Rennen: einen Standort vorgaukeln, damit
// Routing / Pit-Stop / "Voraus" so tun, als wäre man woanders. Aktiviert wird
// das im Profil (Admin-Bereich); GESETZT wird der Punkt per Long-Press auf die
// Karte. Solange aktiv, überschreibt die simulierte Position das echte GPS für
// alle Reader (via positionBus).
//
// Persistenz: der Enable-Flag liegt als bool-Pref (useBoolPreference → '1'/'0')
// unter SIM_ENABLED_PREF, die Koordinaten als JSON unter SIM_COORDS_KEY. So
// bleibt der Test-Standort über Reloads erhalten, bis man ihn im Profil abschaltet.

import { positionBus, makeSimCoords } from './positionBus';

export const SIM_ENABLED_PREF = 'adt_sim_enabled';
const SIM_COORDS_KEY = 'adt_sim_coords';

export function loadSimCoords(): { lat: number; lon: number } | null {
  try {
    const raw = localStorage.getItem(SIM_COORDS_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as { lat?: unknown; lon?: unknown };
    if (typeof o.lat === 'number' && typeof o.lon === 'number') {
      return { lat: o.lat, lon: o.lon };
    }
  } catch {
    /* korrupt → ignorieren */
  }
  return null;
}

/** Test-Standort setzen (Long-Press) — persistiert + an positionBus. Heading
 *  bewusst null: die Fahrtrichtung kommt zur Laufzeit aus der gefahrenen GPX
 *  (routeBus) bzw. dem GPS, nicht aus einem fixen Wert. */
export function setSimLocation(lat: number, lon: number): void {
  try {
    localStorage.setItem(SIM_COORDS_KEY, JSON.stringify({ lat, lon }));
  } catch {
    /* quota/private mode — egal */
  }
  positionBus.setSimulated(makeSimCoords(lat, lon, null));
}

/** Simulation komplett aus: positionBus zurück auf echtes GPS, Koords löschen. */
export function clearSimLocation(): void {
  try {
    localStorage.removeItem(SIM_COORDS_KEY);
  } catch {
    /* egal */
  }
  positionBus.setSimulated(null);
}

/** Beim App-/Karten-Start: wenn aktiviert + Koords vorhanden → anwenden. */
export function restoreSimIfEnabled(): void {
  let enabled = false;
  try {
    enabled = localStorage.getItem(SIM_ENABLED_PREF) === '1';
  } catch {
    return;
  }
  if (!enabled) return;
  const c = loadSimCoords();
  if (c) positionBus.setSimulated(makeSimCoords(c.lat, c.lon, null));
}
